import {Joyride, STATUS} from "react-joyride";

const steps = [
    {
        target: '[data-tour="create-project-form"]',
        title: "Set up your project",
        content: "Complete the project details here. Choose the name, language, voice, and deployment options.",
        placement: "left-start",
        skipBeacon: true,
    },
    {
        target: '[data-tour="create-project-submit"]',
        title: "Create your project",
        content: "When the required fields are complete, select Submit to create your project.",
        placement: "top",
        skipBeacon: true,
    },
];

export const CreateProjectTour = ({run = false, onFinish}) => (
    <Joyride
        key={String(run)}
        steps={steps}
        run={run}
        continuous
        arrowComponent={() => null}
        options={{
            buttons: ["skip", "primary"],
            showProgress: true,
            offset: 18,
            scrollOffset: 80,
            scrollDuration: 400,
            targetWaitTimeout: 5000,
        }}
        scrollToFirstStep
        locale={{skip: "Skip tour", last: "Finish"}}
        callback={(data) => {
            if (data.status === STATUS.FINISHED || data.status === STATUS.SKIPPED) {
                onFinish?.(data.status);
            }
        }}
        styles={{
            options: {
                primaryColor: "#7467D9",
                textColor: "#625d72",
                backgroundColor: "#FFFFFF",
                overlayColor: "rgba(81, 70, 130, 0.16)",
                arrowColor: "#FFFFFF",
                spotlightPadding: 10,
                spotlightRadius: 16,
                width: 380,
                zIndex: 1500,
            },
            tooltip: {
                background: "linear-gradient(145deg, #ffffff 0%, #fcfbff 100%)",
                border: 0,
                borderRadius: 24,
                boxShadow: "0 24px 60px rgba(55, 42, 96, 0.16), 0 8px 20px rgba(55, 42, 96, 0.08)",
                padding: 28,
            },
            tooltipContainer: {textAlign: "left", lineHeight: 1.55},
            tooltipTitle: {
                color: "#2f2850",
                fontSize: 20,
                fontWeight: 750,
                letterSpacing: "-0.02em",
                margin: 0,
            },
            tooltipContent: {fontSize: 14, padding: "8px 0 22px"},
            tooltipFooter: {gap: 8},
            buttonPrimary: {
                background: "linear-gradient(135deg, #7467D9 0%, #9B7CF6 100%)",
                border: 0,
                borderRadius: 999,
                boxShadow: "0 7px 16px rgba(116, 103, 217, 0.24)",
                fontSize: 13,
                fontWeight: 700,
                outline: 0,
                padding: "12px 20px",
            },
            buttonSkip: {
                background: "rgba(116, 103, 217, 0.08)",
                border: 0,
                borderRadius: 999,
                boxShadow: "0 4px 10px rgba(116, 103, 217, 0.08)",
                color: "#7467D9",
                fontSize: 13,
                fontWeight: 600,
                outline: 0,
                padding: "12px 16px",
            },
            buttonClose: {border: 0, color: "#8f89a1", outline: 0},
        }}
    />
);

export default CreateProjectTour;
